var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconContactUsLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M7.19 13.56H5.7a1.73 1.73 0 0 0-1.08.4v-2.29a9.59 9.59 0 0 1 2.77-6.75 1 1 0 0 0 0-1.37A1 1 0 0 0 6 3.56a11.57 11.57 0 0 0-3.32 8.11V15a1 1 0 0 0-.91 1v4.63a1.47 1.47 0 0 0 1.48 1.47H4a1.69 1.69 0 0 0 1.7 1.47h1.49c.94 0 1.704-.76 1.71-1.7v-6.6a1.72 1.72 0 0 0-1.71-1.71zM3.71 17H4v3.19h-.29V17zM7 21.63H6V15.5h1v6.13zm22.49-6.92v-3A11.74 11.74 0 0 0 17.7 0h-1.55a11.66 11.66 0 0 0-5 1.1 1 1 0 0 0-.48 1.29 1 1 0 0 0 1.33.47 9.79 9.79 0 0 1 4.16-.92h1.54c5.405-.028 9.811 4.325 9.85 9.73v2.72a1.7 1.7 0 0 0-1.62-1.19h-1.49c-.94 0-1.704.76-1.71 1.7v6.6c.006.94.77 1.7 1.71 1.7h1.49c.216 0 .43-.04.63-.12A9.8 9.8 0 0 1 21.07 28a1 1 0 0 0-.95-.86h-2.48a2.36 2.36 0 0 0-1.72.71A2.43 2.43 0 0 0 17.64 32h2.48a1 1 0 0 0 1-1v-1a11.7 11.7 0 0 0 8-8.36 1.48 1.48 0 0 0 1.1-1.42v-4.59a1 1 0 0 0-.73-.92zm-3.79 6.55h-1v-6.12h1v6.12zm-6.55 8.8h-1.51a.52.52 0 0 1-.51-.5.47.47 0 0 1 .16-.35.5.5 0 0 1 .35-.14h1.51v.99zm9.14-10.26H28v-3.2h.28l.01 3.2z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    fillRule: "nonzero",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContactUsLight);
export default __webpack_public_path__ + "static/media/icon-contact-us-light.2ddfa670165a66b620eb03ed55c8e32e.svg";
export { ForwardRef as ReactComponent };